import {
  FETCH_IMPC_WITH_MRD_REQUEST,
  FETCH_IMPC_WITH_MRD_SUCCESS,
  FETCH_IMPC_WITH_MRD_FAILURE, FETCH_ALL_IMPC_SUCCESS, FETCH_ALL_IMPC_FAILURE,
} from './types/ImpcActionTypes';

export function fetchImpcsWithMrdsRequestActionCreator() {
  return {
    type: FETCH_IMPC_WITH_MRD_REQUEST,
  };
}

export function fetchImpcsWithMrdsSuccessActionCreator(payload) {
  return {
    type: FETCH_IMPC_WITH_MRD_SUCCESS,
    payload,
  };
}

export function fetchImpcsWithMrdsFailureActionCreator(error) {
  return {
    type: FETCH_IMPC_WITH_MRD_FAILURE,
    payload: error,
    error: true,
  };
}

export function fetchAllImpcsSuccessActionCreator(payload) {
  return {
    type: FETCH_ALL_IMPC_SUCCESS,
    payload,
  };
}

export function fetchAllImpcsFailureActionCreator(error) {
  return {
    type: FETCH_ALL_IMPC_FAILURE,
    payload: error,
    error: true,
  };
}
